module.exports = __webpack_public_path__ + "static/media/Frame10.0290ef43.jpg";